export default function Logo({ size = 30, testid = "logo-mark", color = "#FFFFFF" }) {
  return (
    <svg
      width={size * 1.5}
      height={size}
      viewBox="0 0 48 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid={testid}
      aria-label="João Garcez - Travel Designer"
    >
      <path
        d="M6 8H16M13 8V21C13 23.9 10.9 25.5 8.6 25.5"
        stroke={color}
        strokeWidth="2.2"
        strokeLinecap="round"
      />
      <path
        d="M39.2 10.6C37.3 8.2 34.3 6.8 31 6.8C25.6 6.8 21.5 10.9 21.5 16C21.5 21.1 25.6 25.2 31 25.2C35.9 25.2 39.6 22 39.6 17.4V16H31.6"
        stroke={color}
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="44" cy="23" r="2.2" fill="#FF5A36" />
    </svg>
  );
}
